import isNil from 'lodash/isNil';
import omitBy from 'lodash/omitBy';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router';

import { routerShape } from '@bibliocommons/bc-prop-types';
import { bindAll } from '@bibliocommons/utils-react';
import { withRouter } from 'app/helpers/routing';

import updateSearchQuery from '../../helpers/search/updateSearchQuery';

import './DidYouMean.scss';

export class DidYouMean extends React.PureComponent {
  constructor(props) {
    super(props);
    bindAll(this);
  }

  render() {
    const { querySuggestion, resultCount, router } = this.props;

    if (!querySuggestion) {
      return null;
    }

    const query = new URLSearchParams(
      omitBy(
        updateSearchQuery({
          currentQuery: router.query,
          origin: 'did-you-mean',
          query: this.props.querySuggestion,
          page: undefined
        }),
        isNil
      )
    ).toString();

    return (
      <div className="cp-did-you-mean">
        <FormattedMessage
          id="form_label_did_you_mean"
          values={{ querySuggestion: <strong>{querySuggestion}</strong> }}
        />
        &nbsp;
        <Link className="did-you-mean-suggestion-link" to={{ pathname: '/v2/search', search: `?${query}` }}>
          <FormattedMessage id="form_label_did_you_mean_view_results" values={{ resultCount }} />
        </Link>
      </div>
    );
  }
}

DidYouMean.displayName = 'DidYouMean';

DidYouMean.propTypes = {
  querySuggestion: PropTypes.string,
  resultCount: PropTypes.number,
  router: routerShape.isRequired
};

export default withRouter(DidYouMean);
